import React from 'react';
import { Link, Text } from '@radix-ui/themes';

interface ResourceLinkProps {
  id: string;
  name: string;
  path: string;
}

/**
 * Reusable component for displaying resource names as clickable links
 * Can be used for entities, workflows, lists, or any other named resource
 */
const ResourceLink: React.FC<ResourceLinkProps> = ({ id, name, path }) => (
  <Link href={`${path}/${id}`} size="2">
    <Text color="blue">{name}</Text>
  </Link>
);

export default ResourceLink;
